import { emitDebugEvent } from "../../components/debug/debug-store";

import type { ApiErrorKind } from "./api-error";

interface ApiDiagnostic {
  operation: string;
  status: "started" | "succeeded" | "failed" | "cancelled" | "outcome-unknown";
  route: string;
  durationMs?: number;
  correlationId?: string;
  errorCode?: string;
  errorKind?: ApiErrorKind;
}

export function recordApiDiagnostic(diagnostic: ApiDiagnostic): void {
  emitDebugEvent({
    feature: "apiClient",
    operation: diagnostic.operation,
    status: diagnostic.status,
    route: diagnostic.route,
    durationMs: diagnostic.durationMs,
    correlationId: diagnostic.correlationId,
    errorCode: diagnostic.errorCode ?? diagnostic.errorKind,
  });
}
